module.exports = __webpack_public_path__ + "img/scene2-13.2128e167.jpg";